import { messages } from "./message"


export const creditMemoTotals = [
    "baseCurrencyTotalAmount",
    "baseCurrencyRemainingAmount",
]

export const creditMemoSearchFields = [
    "status",
    "identifier",
    "contact.nameSort",
    "contact.name",
    "contact.nameKeyword",
    "contact.nameAnalyzed",
    "identifierAnalyzed",
    "identifierNumber",
    "identifierKeyword",
    "notes"
]

export const getCreditMemosFilters =  (context) => {   
    return [
        {
            section: context.intl?.formatMessage(messages["most_used_filters"]),
        },
            
        {
            nameId: "identifier",
            label: context.intl?.formatMessage(messages["identifier"]),
            filterMatch: "identifier",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "createdAt",
            label: context.intl?.formatMessage(messages["created_at"]),
            filterMatch: "createdAt",
            type: "date",
            initialValue: {startDate: null, endDate: null},
            initialSelect: "is"
        },
        {
            nameId: "capturedDate",
            label: context.intl?.formatMessage(messages["captured_date"]),
            filterMatch: "capturedDate",
            type: "date",
            initialValue: {startDate: null, endDate: null},
            initialSelect: "is"
        },
        {
            nameId: "status",
            label: context.intl?.formatMessage(messages["status"]),
            type: "select",
            filterMatch: "status",
            typeOfSelect: "credit-memo-status-select",
            placeHolder: context.intl?.formatMessage(messages["status_filter_placeholder"]),
            initialValue: [],
            initialSelect: "isOneOf"
        },
        {
            nameId: "amount",
            label: context.intl?.formatMessage(messages["amount"]),
            nameField: "amount",
            filterMatch: "amount",
            type: "number",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "remainingAmount",
            label: context.intl?.formatMessage(messages["remaining_amount"]),
            nameField: "remainingAmount",
            filterMatch: "remainingAmount",
            type: "number",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "refundedAmount",
            label: context.intl?.formatMessage(messages["refunded_amount"]),
            nameField: "refundedAmount",
            filterMatch: "refundedAmount",
            type: "number",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "isArchived",
            label: context.intl?.formatMessage(messages["is_archived"]),
            filterMatch: "isArchived",
            type: "boolean",
            placeHolder: "Show archived",
            initialValue: "",
            initialSelect: "is",
        },
        {
            nameId: "effectiveDate",
            label: context.intl?.formatMessage(messages["effective_date"]),
            filterMatch: "effectiveDate",
            type: "date",
            initialValue: {startDate: null, endDate: null},
            initialSelect: "is"
        },
        {
            nameId: "notesKeyword",
            label: context.intl?.formatMessage(messages["notes"]),
            filterMatch: "notesKeyword.keyword",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            section: context.intl?.formatMessage(messages["advanced_filters"]),
        },
        {
            nameId: "payment_id",
            label: context.intl?.formatMessage(messages["payment_id"]),
            filterMatch: "paymentId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "created_from_payment_id",
            label: context.intl?.formatMessage(messages["created_from_payment_id"]),
            filterMatch: "createdFromPaymentId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "invoiceReferenceId",
            label: context.intl?.formatMessage(messages["invoice_reference_id"]),
            filterMatch: "invoiceReferenceId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
            
        {
            nameId: "quoteReferenceIdKeyword",
            label: context.intl?.formatMessage(messages["quote_reference_id_keyword"]),
            filterMatch: "quoteReferenceIdKeyword",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        }, 
        {
            nameId: "orderReferenceId",
            label: context.intl?.formatMessage(messages["order_reference_id"]),
            filterMatch: "orderReferenceId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "priceListReferenceId",
            label: context.intl?.formatMessage(messages["price_list_reference_id"]),
            filterMatch: "priceListReferenceId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "uniqueExternalId",
            label: context.intl?.formatMessage(messages["unique_external_id"]),
            filterMatch: "uniqueExternalId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        {
            nameId: "creditMemoReferenceId",
            label: context.intl?.formatMessage(messages["credit_memo_reference_id"]),
            filterMatch: "creditMemoReferenceId",
            type: "text",
            initialValue: "",
            initialSelect: "is"
        },
        
    ]

}



// WEBPACK FOOTER //
// ./src/common/search-filter/search/creditMemosFilters/creditMemosFilters.tsx